module.exports = __webpack_public_path__ + "img/ts.4e96f111.png";